import { render, staticRenderFns } from "./ApprovalFeedback.vue?vue&type=template&id=5084ef54&scoped=true"
import script from "./ApprovalFeedback.vue?vue&type=script&lang=js"
export * from "./ApprovalFeedback.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFeedback.vue?vue&type=style&index=0&id=5084ef54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084ef54",
  null
  
)

export default component.exports